import { useEffect, useState } from 'react';
import { Role } from '@sodamnfoolish/spl-factory-backend-automatization';
import { createAutomatizationGatewayClient } from '../utils/automatization';
import { useUrlParams } from './useUrlParams';
import { Socket } from 'socket.io-client';

export const useAutomatizationGateway = (validateRole: (role: Role) => boolean) => {
    const { automatization } = useUrlParams();

    const [automatizationRole, setAutomatizationRole] = useState<Role>();
    const [automatizationClient, setAutomatizationClient] = useState<Socket>();

    useEffect(() => {
        if (!automatization) return;

        if (!validateRole(automatization!.role)) throw new Error('Wrong role for automatization');

        setAutomatizationRole(automatization!.role);

        const automatizationClient = createAutomatizationGatewayClient(
            process.env.REACT_APP_MINT_TS_BACKEND!,
            process.env.REACT_APP_MINT_TS_BACKEND_APIKEY!,
            automatization!.room,
            automatization!.role,
        );

        automatizationClient.on('connect', () => console.debug('Automatization client connected', automatizationClient.id));
        automatizationClient.on('connect_error', () => console.debug('Automatization client connection error'));
        automatizationClient.on('disconnect', () => console.debug('Automatization client disconnected'));

        automatizationClient.connect();

        setAutomatizationClient(automatizationClient);

        return () => {
            automatizationClient.off('connect');
            automatizationClient.off('connect_error');
            automatizationClient.off('disconnect');
            automatizationClient.disconnect();
        };
    }, [automatization]);

    return {
        automatizationRole,
        automatizationClient,
    };
};
